module.exports = __webpack_public_path__ + "static/media/ico_view_o.f8447ccc.svg";